/* ============================================================
   HENNAFY JEWEL — Theme JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', function () {

  // ---- CART DRAWER ----
  const cartDrawer = document.getElementById('cart-drawer');
  const cartTriggers = document.querySelectorAll('[data-cart-open]');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }
  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  cartTriggers.forEach(el => el.addEventListener('click', openCart));
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // ---- MOBILE NAV ----
  const hamburger = document.querySelector('.header__hamburger');
  const mobileNav = document.querySelector('.header__nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      const open = mobileNav.style.display === 'flex';
      mobileNav.style.display = open ? 'none' : 'flex';
      mobileNav.style.flexDirection = open ? '' : 'column';
      mobileNav.style.position = open ? '' : 'absolute';
      mobileNav.style.top = open ? '' : '100%';
      mobileNav.style.left = open ? '' : '0';
      mobileNav.style.right = open ? '' : '0';
      mobileNav.style.background = open ? '' : 'var(--color-bg)';
      mobileNav.style.padding = open ? '' : '1.5rem var(--gutter)';
      mobileNav.style.borderBottom = open ? '' : '1px solid var(--color-border)';
    });
  }

  // ---- PRODUCT GALLERY THUMBS ----
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) {
        mainImg.src = thumb.querySelector('img').src;
        mainImg.srcset = thumb.querySelector('img').srcset || '';
      }
    });
  });

  // ---- QUICK ADD TO CART ----
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'Adding...';
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          btn.textContent = 'Added!';
          await updateCartCount();
          openCart();
          setTimeout(() => { btn.textContent = 'Quick Add'; }, 2500);
        } else {
          btn.textContent = 'Quick Add';
        }
      } catch {
        btn.textContent = 'Quick Add';
      }
    });
  });

  // ---- ADD TO CART (product page) ----
  const addToCartForm = document.querySelector('.product-info__form');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', async function (e) {
      e.preventDefault();
      const formData = new FormData(addToCartForm);
      const btn = addToCartForm.querySelector('[type="submit"]');
      btn.textContent = 'Adding...';
      btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: formData.get('id'),
            quantity: parseInt(formData.get('quantity') || 1)
          })
        });
        if (res.ok) {
          await updateCartCount();
          openCart();
        }
      } finally {
        btn.textContent = 'Add to Bag';
        btn.disabled = false;
      }
    });
  }

  // ---- VARIANT SELECTOR ----
  document.querySelectorAll('.option-value').forEach(opt => {
    opt.addEventListener('click', function () {
      const group = opt.closest('.product-info__option-values');
      group.querySelectorAll('.option-value').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      updateVariantId();
    });
  });

  function updateVariantId() {
    const selectedOptions = [];
    document.querySelectorAll('.product-info__option-values').forEach(group => {
      const sel = group.querySelector('.option-value.selected');
      if (sel) selectedOptions.push(sel.dataset.value);
    });
    const variantsData = window.productVariants || [];
    const match = variantsData.find(v =>
      v.options.every((o, i) => o === selectedOptions[i])
    );
    const idInput = document.querySelector('input[name="id"]');
    if (match && idInput) {
      idInput.value = match.id;
    }
  }

  // ---- CART COUNT UPDATE ----
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch {}
  }
  updateCartCount();

  // ---- NEWSLETTER FORM ----
  const newsletterForm = document.querySelector('.newsletter__form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      e.preventDefault();
      const email = newsletterForm.querySelector('.newsletter__input').value;
      if (email) {
        newsletterForm.innerHTML = '<p style="color:var(--color-gold);font-size:0.9rem;letter-spacing:0.1em;">Thank you for joining the Hennafy family.</p>';
      }
    });
  }

  // ---- SCROLL FADE-IN ----
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.fade-in').forEach(el => observer.observe(el));

  // ---- STICKY HEADER SHADOW ----
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.style.boxShadow = window.scrollY > 10
        ? '0 2px 20px rgba(0,0,0,0.08)'
        : 'none';
    });
  }

});
